import { render, staticRenderFns } from "./RelatorioCampanhasWhatsapp.vue?vue&type=template&id=39498798"
import script from "./RelatorioCampanhasWhatsapp.vue?vue&type=script&lang=js"
export * from "./RelatorioCampanhasWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports